import * as React from "react";
import type { SVGProps } from "react";
const SvgSupport = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M32 1.813c-11.155 0-20.125 8.602-20.125 19.125a.875.875 0 0 1-1.75 0C10.125 9.367 19.959.063 32 .063c12.04 0 21.875 9.306 21.875 20.875a.875.875 0 0 1-1.75 0c0-10.523-8.97-19.125-20.125-19.125Z"
      clipRule="evenodd"
    />
    <path fill="#D3ECF8" d="M37 55.938a4 4 0 0 1 0 8h-9a4 4 0 0 1 0-8h9Z" />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M28 62.188h9a2.25 2.25 0 0 0 0-4.5h-9a2.25 2.25 0 0 0 0 4.5Zm13-2.25a4 4 0 0 0-4-4h-9a4 4 0 0 0 0 8h9a4 4 0 0 0 4-4Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M53.875 45.938v2c0 7.662-6.212 13.874-13.875 13.874v-1.75c6.697 0 12.125-5.428 12.125-12.124v-2h1.75Z"
      clipRule="evenodd"
    />
    <path fill="#D3ECF8" d="M57 24.938a4 4 0 0 0-8 0v18a4 4 0 0 0 8 0v-18Z" />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M50.75 42.938v-18a2.25 2.25 0 0 1 4.5 0v18a2.25 2.25 0 0 1-4.5 0Zm2.25-22a4 4 0 0 1 4 4v18a4 4 0 0 1-8 0v-18a4 4 0 0 1 4-4Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M59.483 27.447c.997 1.745 1.642 4.215 1.642 6.99 0 2.776-.645 5.246-1.642 6.991-1.012 1.77-2.276 2.635-3.483 2.635a.875.875 0 0 0 0 1.75c2.106 0 3.842-1.487 5.002-3.517 1.175-2.055 1.873-4.835 1.873-7.858 0-3.024-.698-5.804-1.873-7.86-1.16-2.03-2.896-3.515-5.002-3.515a.875.875 0 0 0 0 1.75c1.207 0 2.471.864 3.483 2.634Z"
      clipRule="evenodd"
    />
    <path fill="#D3ECF8" d="M7 24.938a4 4 0 0 1 8 0v18a4 4 0 0 1-8 0v-18Z" />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M13.25 42.938v-18a2.25 2.25 0 0 0-4.5 0v18a2.25 2.25 0 0 0 4.5 0Zm-2.25-22a4 4 0 0 0-4 4v18a4 4 0 0 0 8 0v-18a4 4 0 0 0-4-4Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M4.517 27.447c-.997 1.745-1.642 4.215-1.642 6.99 0 2.776.645 5.246 1.642 6.991C5.53 43.198 6.793 44.063 8 44.063a.875.875 0 0 1 0 1.75c-2.106 0-3.842-1.487-5.002-3.517-1.175-2.055-1.873-4.835-1.873-7.858 0-3.024.698-5.804 1.873-7.86 1.16-2.03 2.896-3.515 5.002-3.515a.875.875 0 0 1 0 1.75c-1.207 0-2.471.864-3.483 2.634Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSupport;
